import React from 'react';
import PropTypes from 'prop-types';
import languageHelper from 'helpers/languages';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const StyledSection = styled.div`
    display: block;
    margin: 30px 0;

    &:last-child {
        margin: 30px 0 0;
    }
`;

const StyledItemSection = styled.div`
    display: flex;
    margin-bottom: 10px;

    &:last-child {
        margin: 0;
    }
`;

const StyledLabel = styled.div`
    display: block;
    font-size: 12px;
    line-height: 22px;
    margin-bottom: 5px;
    color: ${ theme.palette.doveGray };
`;

const StyledLocalisation = styled.div`
    display: block;
`;

const StyledHeader = styled.div`
    margin: 0 0 20px;
    padding: 0 0 5px;
    font-size: 14px;
    line-height: 1;
    border-bottom: 1px solid black;
`;

const StyledItemLabel = styled(StyledLabel)`
    display: inline-block;
    min-width: 250px;
`;

const StyledItemValue = styled.div`
    display: inline-block;
`;

const LocalisationItem = (props) => {
    const {
        label,
        value,
    } = props;

    return (
        <StyledItemSection>
            <StyledItemLabel>{ label }</StyledItemLabel>

            <StyledItemValue>{ value }</StyledItemValue>
        </StyledItemSection>
    );
};

LocalisationItem.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
};

const LocalisationValues = (props) => {
    const {
        localisation,
        translate,
    } = props;

    const locales = Object.keys(localisation);

    if (!locales.length) {
        return null;
    }

    return (
        <StyledLocalisation>
            { locales.map((locale) => {
                if (!localisation.hasOwnProperty(locale)) {
                    return;
                }

                const localeValue = localisation[locale];
                const language = languageHelper.getLabel(locale);

                return (
                    <StyledSection key={ locale }>
                        <StyledHeader>
                            { translate(`languages.${ language.toLowerCase() }`) }
                        </StyledHeader>

                        {
                            utils.map(localeValue, (value, label) => {
                                return <LocalisationItem
                                    key={ `${ label }_${ value }` }
                                    label={ utils.formatPropertyName(label) }
                                    value={ value }
                                />;
                            })
                        }
                    </StyledSection>
                );
            }) }
        </StyledLocalisation>
    );
};

LocalisationValues.propTypes = {
    localisation: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const ProductLocalisationShow = (props) => {
    const {
        localisation,
        translate,
    } = props;

    return <LocalisationValues
        localisation={ localisation }
        translate={ translate }
    />;
};

ProductLocalisationShow.propTypes = {
    localisation: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductLocalisationShow);



// WEBPACK FOOTER //
// ./src/pages/products/productLocalisation/show/ProductLocalisationShow.js